import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import { UserContext } from "../../context/UserContext";

const Sidebar = ({ toggleSidebar, setToggleValue }) => {
  const location = useLocation();
  const auth = useContext(UserContext);
  const { logout } = useContext(UserContext);
  const navigate = useNavigate();

  const [showDropdown, setShowDropdown] = useState(false);
  const [showOrderDropdown, setOrderShowDropdown] = useState(false);
  const [showProfilerDropdown, setProfileShowDropdown] = useState(false);

  useEffect(() => {
    if (auth?.user?.userType) {
      localStorage.setItem("userType", auth.user.userType);
    }
  }, [auth?.user]);

  const handleLogout = () => {
    // Clear the token
    localStorage.removeItem("token");
    localStorage.removeItem("userType");
    localStorage.removeItem("orderDetails");
    localStorage.removeItem("orderNumber");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("email");

    logout();

    navigate("/login");
  };

  const userType = localStorage.getItem("userType");

  return (
    <div
      className={`dashboard-sidebar`}
    >
      <div className="sidebar-wrapper mt-5">
        <div className="sidebar-header">
          <h5 className="text-white mb-0">Dashboard</h5>
        </div>
        <div className="sidebar-content">
          {auth?.user?.isActive === 1 || auth?.user?.isActive === 2 ? (
            <div
              className={`sidebar-link-wrapper ${location.pathname === "/" ? "active" : ""
                }`}
            >
              <Link to="/" className="sidebar-link">
                <Icon.House className="sidebar-icon" />
                <span>Home</span>
              </Link>
            </div>
          ) : (
            ""
          )}
          {auth?.user?.isActive === 1 && (
            <div
              className={`sidebar-link-wrapper ${location.pathname === "/dashboard" ? "active" : ""
                }`}
            >
              <Link to="/dashboard" className="sidebar-link">
                <Icon.PieChart className="sidebar-icon" />
                <span>Dashboard</span>
              </Link>
            </div>
          )}
          {auth?.user?.isActive === 1 && auth.user?.userType === "admin" ? (
            <div
              className={`sidebar-link-wrapper ${location.pathname === "/admins" ? "active" : ""
                }`}
            >
              <Link to="/admins" className="sidebar-link">
                <Icon.PersonSquare className="sidebar-icon" />
                <span>Admins</span>
              </Link>
            </div>
          ) : (
            ""
          )}

          {(auth?.user?.isActive === 1 || auth?.user?.isActive === 2) && (
            <div
              className={`sidebar-link-wrapper has-dropdown ${["/userprofile", "/changepassword"].includes(location.pathname) ? "active" : ""
                }`}
              onMouseEnter={() =>
                auth?.user?.userType && setProfileShowDropdown(true)
              }
              onMouseLeave={() => setProfileShowDropdown(false)}
            >
              <Link to="/userprofile" className="sidebar-link">
                <Icon.PersonCircle className="sidebar-icon" />
                <span>Profile</span>
                <Icon.ChevronRight className="dropdown-arrow" />
              </Link>

              {showProfilerDropdown && (
                <div className="sidebar-dropdown">
                  <Link
                    to="/userprofile"
                    className={`sidebar-dropdown-item ${location.pathname === "/userprofile" ? "active" : ""
                      }`}
                  >
                    <Icon.Person className="sidebar-icon" />
                    <span>View Profile</span>
                  </Link>
                  <Link
                    to="/changepassword"
                    className={`sidebar-dropdown-item ${location.pathname === "/changepassword" ? "active" : ""
                      }`}
                  >
                    <Icon.Key className="sidebar-icon" />
                    <span>Change Password</span>
                  </Link>
                </div>
              )}
            </div>
          )}

          {/* ---------------------for No drop down user and admin-------------------------------- */}

          {auth?.user?.isActive === 1 && (
            <div
              className={`sidebar-link-wrapper has-dropdown ${[
                "/orders",
                "/allorders",
                "/allsellerorderlist",
                "/allorderofseller",
              ].includes(location.pathname)
                ? "active"
                : ""
                }`}
              onMouseEnter={() => {
                if (
                  auth?.user?.userType === "admin" ||
                  auth?.user?.userType === "distributor"
                ) {
                  setOrderShowDropdown(true);
                }
              }}
              onMouseLeave={() => setOrderShowDropdown(false)}
            >
              <Link
                to={
                  userType === "admin" || userType === "distributor"
                    ? "/allorderofseller"
                    : "/orders"
                }
                className="sidebar-link"
              >
                <Icon.Bag className="sidebar-icon" />
                <span>{userType === "admin" || userType === "distributor"
                  ? "Orders"
                  : "My Orders"}</span>
                {(auth?.user?.userType === "admin" || auth?.user?.userType === "distributor") && (
                  <Icon.ChevronRight className="dropdown-arrow" />
                )}
              </Link>

              {auth?.user?.userType === "admin" && showOrderDropdown && (
                <div className="sidebar-dropdown">
                  <Link
                    to="/allorders"
                    className={`sidebar-dropdown-item ${location.pathname === "/allorders" ? "active" : ""
                      }`}
                  >
                    <Icon.Cart className="sidebar-icon" />
                    <span>Buyer Orders</span>
                  </Link>
                  <Link
                    to="/allsellerorderlist"
                    className={`sidebar-dropdown-item ${location.pathname === "/allsellerorderlist"
                      ? "active"
                      : ""
                      }`}
                  >
                    <Icon.Shop className="sidebar-icon" />
                    <span>Seller Orders</span>
                  </Link>
                  <Link
                    to="/orders"
                    className={`sidebar-dropdown-item ${location.pathname === "/orders"
                      ? "active"
                      : ""
                      }`}
                  >
                    <Icon.Bag className="sidebar-icon" />
                    <span>My Orders</span>
                  </Link>
                </div>
              )}
              {auth?.user?.userType === "distributor" && showOrderDropdown && (
                <div className="sidebar-dropdown">
                  <Link
                    to="/orders"
                    className={`sidebar-dropdown-item ${location.pathname === "/orders" ? "active" : ""
                      }`}
                  >
                    <Icon.Bag className="sidebar-icon" />
                    <span>My Orders</span>
                  </Link>
                </div>
              )}
            </div>
          )}

          {/* -------------------------------------------------------------------------------------- */}

          {(auth?.user?.isActive === 1 && userType === "distributor") ||
            userType === "admin" ? (
            <div
              className={`sidebar-link-wrapper ${location.pathname === "/addcategories" ? "active" : ""
                }`}
            >
              <Link to="/addcategories" className="sidebar-link">
                <Icon.Tag className="sidebar-icon" />
                <span>Categories</span>
              </Link>
            </div>
          ) : (
            ""
          )}

          {(auth?.user?.isActive === 1 && userType === "distributor") ||
            userType === "admin" ? (
            <div
              className={`sidebar-link-wrapper ${location.pathname === "/addsubcategories" ? "active" : ""
                }`}
            >
              <Link to="/addsubcategories" className="sidebar-link">
                <Icon.Tags className="sidebar-icon" />
                <span>Subcategories</span>
              </Link>
            </div>
          ) : (
            ""
          )}

          {/* -------------------------Products------------------------- */}
          {auth?.user?.isActive === 1 && (
            <>
              {
                userType === "admin" || userType === "distributor" ? (
                  <div
                    className={`sidebar-link-wrapper has-dropdown ${["/products", "/all-products"].includes(location.pathname) ? "active" : ""
                      }`}
                    onMouseEnter={() =>
                      auth?.user?.userType === "admin" && setShowDropdown(true)
                    }
                    onMouseLeave={() => setShowDropdown(false)}
                  >
                    <Link to="/products" className="sidebar-link">
                      <Icon.Box className="sidebar-icon" />
                      <span>Products</span>
                      {userType === "admin" && (
                        <Icon.ChevronRight className="dropdown-arrow" />
                      )}
                    </Link>

                    {userType === "admin" && showDropdown && (
                      <div className="sidebar-dropdown">
                        <Link to="/products" className="sidebar-dropdown-item">
                          <Icon.Box className="sidebar-icon" />
                          <span>My Products</span>
                        </Link>
                        <Link to="/all-products" className="sidebar-dropdown-item">
                          <Icon.Grid3x3Gap className="sidebar-icon" />
                          <span>All Products</span>
                        </Link>
                      </div>
                    )}
                  </div>
                ) : null
              }
            </>
          )}

          {/* -------------------------------------------test-------------------------------*/}

          {auth?.user?.isActive === 1 && (
            <div
              className={`sidebar-link-wrapper ${location.pathname === "/tree" ? "active" : ""
                }`}
            >
              <Link to="/tree" className="sidebar-link">
                <Icon.Diagram3 className="sidebar-icon" />
                <span>Network Tree</span>
              </Link>
            </div>
          )}

          {auth?.user?.isActive === 1 && (
            <div
              className={`sidebar-link-wrapper ${location.pathname === "/commission" ? "active" : ""
                }`}
            >
              <Link to="/commission" className="sidebar-link">
                <Icon.CashCoin className="sidebar-icon" />
                <span>Payouts</span>
              </Link>
            </div>
          )}

          {auth?.user?.isActive === 1 && (
            <div
              className={`sidebar-link-wrapper ${location.pathname === "/contact" ? "active" : ""
                }`}
            >
              <Link to="/contact" className="sidebar-link">
                <Icon.Telephone className="sidebar-icon" />
                <span>Contact</span>
              </Link>
            </div>
          )}

          {userType === "admin" && (
            <div
              className={`sidebar-link-wrapper ${location.pathname === "/gst-catalogue" ? "active" : ""
                }`}
            >
              <Link to="/gst-catalogue" className="sidebar-link">
                <Icon.Receipt className="sidebar-icon" />
                <span>GST Catalogue</span>
              </Link>
            </div>
          )}
          {userType === "admin" && (
            <div
              className={`sidebar-link-wrapper ${location.pathname === "/cms" ? "active" : ""
                }`}
            >
              <Link to="/cms" className="sidebar-link">
                <Icon.FileText className="sidebar-icon" />
                <span>Content Management</span>
              </Link>
            </div>
          )}

          {userType === "admin" && (
            <div
              className={`sidebar-link-wrapper ${location.pathname === "/report" ? "active" : ""
                }`}
            >
              <Link to="/report" className="sidebar-link">
                <Icon.BarChart className="sidebar-icon" />
                <span>User Reports</span>
              </Link>
            </div>
          )}

          <div className="sidebar-link-wrapper logout-section">
            <Link
              to="/login"
              className="sidebar-link logout-link"
              onClick={handleLogout}
            >
              <Icon.BoxArrowRight className="sidebar-icon" />
              <span>Logout</span>
            </Link>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Sidebar;
